import { render } from "./webHeaderDesktop.vue?vue&type=template&id=0cb9f7f1&scoped=true&ts=true"
import script from "./webHeaderDesktop.vue?vue&type=script&lang=ts"
export * from "./webHeaderDesktop.vue?vue&type=script&lang=ts"

import "./webHeaderDesktop.vue?vue&type=style&index=0&id=0cb9f7f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb9f7f1"]])

export default __exports__